//#region Libraries
//#endregion
//#region Styles
import { 
    Container, 
    Footer } from "../styles";
import { Image } from "./styles";
import { Content } from "components/DialogAlertAction/styles";
//#endregion
//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
//#endregion
//#region Images
import successImg from "../img/success_img.svg";
//#endregion

const DialogAlertSuccessNotifyNoOverlayClose = ({
    dialogShow, closeDialog,
    children, variant,
    title, subtitle, 
    description, contentComponent
}) => {
    return (
        <DialogAlert
            close={closeDialog}
            show={dialogShow.value}
            toggleShow={dialogShow.toggle}>
            <Container>
                <Content>
                    <Image src={successImg} alt="Imagen de creación de evento exitoso UTP"/>
                    <h3 className={variant}>{title}</h3>
                    {subtitle && <h4>{subtitle}</h4>}
                    {contentComponent && contentComponent}
                    {description && <p className="paragraph">{description}</p>}
                </Content>
                <Footer>
                    {children}
                </Footer>
            </Container>
        </DialogAlert>
    );
}

export default DialogAlertSuccessNotifyNoOverlayClose;